import Vue from 'vue'
import request from "./config/http.js"
import params from "./config/params.js"

let url="/web_ncp";
const apis = {
  getChannelList(data) { // 一级栏目列表接口展示栏目列表
     return request({
      url:url+"/getChannelList",
      method:'post',
      data:data,
      jsonString:true,
    }).then((resault) => {
        return Promise.resolve(resault.data)
    })
  },
  getBannerList(data) {
     return request({
      url:url+"/getBannerList",
      method:'post',
      data:data,
      jsonString:true,
    }).then((resault) => {
        return Promise.resolve(resault.data)
    })
  },
  gengduoList(data){
    return request({
      url: url+"/gengduoList",
      method: 'post',
      data:data,
      jsonString:true
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  tongyongList(articleLocation,pageSize,channelId){
    return request({
      url: url+"/tongyongList",
      method: 'post',
      data:{
        pageSize:pageSize,
        pageNum:1,
        channelId1:channelId,
        articleLocation:articleLocation,
      },
      jsonString:true
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  shujuList(type) {
    return request({
      url: url+"/shujuList",
      method: 'post',
      data:{},
      jsonString:true
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },

  getList(path,pageSize,pageNum){
    return request({
      url: path,
      method: 'post',
      data:{
        pageSize:pageSize,
        pageNum:pageNum||1,
      },
      jsonString:true
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },
  findArticleList(data,path) {
     return request({
      url:path,
      method:'post',
      data:data,
      jsonString:true,
    }).then((resault) => {
        return Promise.resolve(resault.data)
    })
  },
  findArticle(id) { //网络首发的详情
     return request({
      url: url+"/findArticle",
      method:'post',
      data:{
        articleId:id
      },
      jsonString:true,
    }).then((resault) => {
        return Promise.resolve(resault.data)
    })
  },


  findThesisList(data,baseURL) { //
     return request({
      url: baseURL+"/web_thesis/findThesisList",
      method:'get',
      params:data,
    }).then((resault) => {
        return Promise.resolve(resault.data)
    })
  },
  findThesisById(articleId,baseURL) { //
     return request({
      url: baseURL+"/web_thesis/findThesisById",
      method:'get',
      params:{
        articleId:articleId,
      },
    }).then((resault) => {
        return Promise.resolve(resault.data)
    })
  },
  findFirstThesisList(params,baseURL) { //栏目
     return request({
      url: baseURL+"/web_thesis/findFirstThesisList",
      method:'post',
      isString:true,
      params:{
        articleId:params,
      },
    }).then((resault) => {
        return Promise.resolve(resault.data)
    })
  },
  findSite(data,baseURL) { //首页顶部logo + css样式
     return request({
      url: baseURL+"/web_common/findSite",
      method:'post',
      data:data,
      jsonString:true,
    }).then((resault) => {
        return Promise.resolve(resault.data)
    })
  },
  searchArticleList(data,baseURL) { //站内搜索接口
     return request({
      url: baseURL+"/web_index/searchArticleList",
      method:'post',
      data:data,
      jsonString:true,
    }).then((resault) => {
        return Promise.resolve(resault.data)
    })
  },

  getChannelTwoList(parentId,baseURL) { //二级栏目列表接口
     return request({
      url: baseURL+"/web_common/getChannelTwoList",
      method:'post',
      data:{
        level:2,
        parentId:parentId
      },
      jsonString:true,
    }).then((resault) => {
        return Promise.resolve(resault.data)
    })
  },
  findThesisById(data,baseURL) { //单条论文展示功能(包含已出版和网络首发)
     return request({
      url: baseURL+"/web_thesis/findThesisById",
      method:'get',
      params:data,
      jsonString:true,
    }).then((resault) => {
        return Promise.resolve(resault.data)
    })
  },


  findPeriodList(data,baseURL) {
     return request({
      url: baseURL+"/web_common/findPeriodList",
      method:'post',
      data:data,
      jsonString:true,
    }).then((resault) => {
        return Promise.resolve(resault.data)
    })
  },


  findSinglePage(id,baseURL) { //单页接口
    return request({
      url: baseURL+"/web_common/findSinglePage",
      method: 'post',
      data:{
        bannerId:id,
      },
      jsonString:true
    }).then((resault) => {
      return Promise.resolve(resault.data)
    })
  },


}

export default apis



// WEBPACK FOOTER //
// ./src/core/api/manage.serve.js